const round = (value, digits) => {
  const pow = 10 ** digits;
  return Math.round(value * pow) / pow;
};
export {
  round
};
